export default "__VITE_ASSET__zFat1Pwj__"